import { Logger, LoggerLevel } from '@gr/logger-web';
import { LoggerStorageKey } from '../../../enums/loggerStorageKey';
import { Env } from '../../../helpers/env';

export const EditorLogger = new Logger({
  name: LoggerStorageKey.EDITOR_LOGGER,
  level: Env.isDevelop() ? LoggerLevel.Trace : undefined,
});
